<div class="modal-body">
  <div class="row">
    <h2 class="modal-title">{{ 'brapi-sync.study.heading' | translate }}</h2>
  </div>
  <div class="row">
    <div class="col-10">
      <app-study-selector (onSelect)="onStudySelect()" [trialDisabled]="true"></app-study-selector>
    </div>
  </div>
  @if (loading) {
    <div class="row">
      <div class="col">
        <span class="throbber"></span>
      </div>
    </div>
  }
  <div class="row">
    @if (studyDetail.studyDbId) {
      <div class="col">
        <app-collapsible [heading]="'brapi-sync.study.connection-info' | translate">
          <div class="card">
            <div class="card-body">
              <h5><span class="badge badge-pill text-bg-success text-white">{{studyDetail.studyName}}</span></h5>
            </div>
          </div>
        </app-collapsible>
        <app-collapsible heading="{{studyDetail.studyName + ' Metadata'}}">
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-curved">
              <caption></caption>
              <thead class="thead-light">
                <tr>
                  <th scope="col">{{ 'brapi-sync.study.table.key' | translate }}</th>
                  <th scope="col">{{ 'brapi-sync.study.table.value' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.start-date' | translate }}</span></td>
                  <td>{{studyDetail.startDate}}</td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.end-date' | translate }}</span></td>
                  <td>{{studyDetail.endDate}}</td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.documentation-url' | translate }}</span></td>
                  <td>{{studyDetail.documentationUrl}}</td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.publications' | translate }}</span></td>
                  <td>
                    @if (studyDetail?.publications?.length) {
                      <app-expandable-json-viewer [json]="studyDetail?.publications"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.contacts' | translate }}</span></td>
                  <td>
                    @if (studyDetail?.contacts?.length) {
                      <app-expandable-json-viewer [json]="studyDetail?.contacts"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.additional-info' | translate }}</span></td>
                  <td>
                    @if (studyDetail?.additionalInfo) {
                      <app-expandable-json-viewer [json]="studyDetail?.additionalInfo"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.experimental-design' | translate }}</span></td>
                  <td>
                    @if (studyDetail?.experimentalDesign) {
                      <app-expandable-json-viewer [json]="studyDetail?.experimentalDesign"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
                <tr>
                  <td><span class="fw-bold">{{ 'brapi-sync.study.table.environment-parameters' | translate }}</span></td>
                  <td>
                    @if (studyDetail?.environmentParameters?.length) {
                      <app-expandable-json-viewer [json]="studyDetail?.environmentParameters"></app-expandable-json-viewer>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </app-collapsible>
        <app-collapsible [heading]="'brapi-sync.study.study-location-mapping' | translate">
          <div class="table-responsive">
            <table class="table table-bordered table-striped table-curved">
              <caption></caption>
              <thead class="thead-light">
                <tr>
                  <th scope="col">{{ 'brapi-sync.study.table.source' | translate }}</th>
                  <th scope="col">{{ 'brapi-sync.study.table.target' | translate }}</th>
                  <th scope="col">{{ 'brapi-sync.study.table.status' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{context.sourceStudy.locationName}}</td>
                  <td>{{this.context.targetLocation?.locationName}}</td>
                  <td>
                    @if (this.context.targetLocation?.locationName) {
                      <span><i class="fa fa-check text-success"></i></span>
                    }
                    @if (!this.context.targetLocation?.locationName) {
                      <span><i class="fa fa-times text-danger"></i></span>
                    }
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </app-collapsible>
      </div>
    }
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
  <button type="button" class="btn btn-primary ms-2" (click)="post()" [disabled]="!isValid()">
    @if (loading) {
      <span class="throbber throbber-btn"></span>
    }
    {{ 'brapi-sync.buttons.import-studies' | translate }}
  </button>
  <button type="button" class="btn btn-info ms-2" (click)="next()" [disabled]="!canProceed()">
    {{ 'next' | translate }}
  </button>
</div>


